fragment timeZoneInfo on TimeZone {
  displayName
  displayNameWithOffset
  name
}
